import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthService from "../../services/AuthService";
import Swal from "sweetalert2";
import $ from "jquery";
import { myroutes } from "../../routes/webroute";
import { Col, Row } from "react-bootstrap";


export default function NewPassword() {

    const [email, setEmail] = useState('');
    const [new_password, setNewPassword] = useState('');
    const [new_confirm_password, setNewConfirmPassword] = useState('');
    //const [token, setToken] = useState(null);
    const [loading, isLoading] = useState(false)
    const navigate = useNavigate()

    //get api token
    const { token } = useParams();

    ///###########"METHODES ///////////////"
    const handleSubmit = async (event) => {
        event.preventDefault()
        isLoading(true)
        let form = { email, token, new_password, new_confirm_password }
        await AuthService.changePassword(form).then((response) => {
            if (!response.data.erreur) {
                Swal.fire({
                    icon: 'success',
                    title: 'Félicitations !',
                    text: response.data.message,
                });
                //griser le bouton Valider
                $("#valider").attr("disabled", true)
                isLoading(false)

                //Redirection sur login page
                navigate(myroutes.login);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur!',
                    text: response.data.erreur,
                });
                isLoading(false)
            }
        }).catch(error => {
            isLoading(false)
            Swal.fire({
                icon: 'error',
                title: 'Erreur!',
                text: error.message,
            });
            console.log(error)
        })
    }

    useEffect(() => {
        if (token === null) {
            Swal.fire({
                icon: 'error',
                title: 'Erreur!',
                text: "Vous n'avez pas de token correct !",
            });

            navigate(myroutes.login)
        }
    }, [navigate, token])

    return (
        <React.Fragment>
            <div className="row g-0 app-auth-wrapper">
                <div className="col-12 col-md-8 col-lg-7 auth-main-col text-center p-5">
                    <div className="d-flex flex-column align-content-end">
                        <div className="app-auth-bodyx mx-auto">
                            <div className="app-auth-branding mb-4"><a className="app-logo" href="/"><img className="logo-icon me-2" src="/startup/img/logo-digiweb.png" alt="logo" style={{ width: "100px", height: "100px" }} /></a></div>
                            <h2 className="auth-heading text-center mb-5">Nouveau mot de passe</h2>
                            <div className="auth-form-container text-start">

                                <form className="auth-form resetpass-form" onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={12}>
                                            <div className="email mb-3">
                                                <label className="sr-onlyx fw-bolder" htmlFor="reg-email">Email <i className="text-danger">*</i></label>
                                                <input id="reg-email" value={email} minLength={5} maxLength={100} name="reg-email" type="email" onChange={(e) => setEmail(e.target.value)} className="form-control login-email border border-info" required="required" />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>

                                            <div className="email mb-3">
                                                <label className="sr-onlyx fw-bolder" htmlFor="new_password">Nouveau mot de passe <i className="text-danger">*</i></label>
                                                <input id="new_password" value={new_password} minLength={5} maxLength={100} name="new_password" onChange={(e) => setNewPassword(e.target.value)} type="password" className="form-control login-email border border-info" placeholder="Mot de passe" required="required" />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="email mb-3">
                                                <label className="sr-onlyx fw-bolder" htmlFor="new_confirm_password">Confirmer le mot de passe <i className="text-danger">*</i></label>
                                                <input id="new_confirm_password" value={new_confirm_password} minLength={5} maxLength={100} name="new_confirm_password" onChange={(e) => setNewConfirmPassword(e.target.value)} type="password" className="form-control login-email border border-info" placeholder="Mot de passe" required="required" />
                                            </div>
                                        </Col>
                                    </Row>

                                    <div className="text-center">
                                        <button className="btn app-btn-primary bg-primary text-white w-100 theme-btn mx-auto" id="valider">{loading === false ? "Valider" : "En cours..."}</button>
                                    </div>
                                </form>
                                <div className="auth-option text-center pt-5">Pas de compte?</div>
                                <div className="auth-option text-center pt-2">S'inscrire en tant que  <Link className="text-link" to={myroutes.register} style={{ fontWeight: "bold" }} > Particulier ici</Link>.</div>
                                <div className="auth-option text-center pt-2"> S'inscrire en tant que <Link className="text-link" to={myroutes.register_entreprise} style={{ fontWeight: "bold" }} > Entreprise ici</Link>.</div>

                            </div>{/*//auth-form-container*/}

                        </div>{/*//auth-body*/}

                        <footer className="app-auth-footer">
                            <div className="container text-center py-3">
                                <small className="copyright">Conception réalisée par <span className="sr-only">love</span><i className="fas fa-heart" style={{ color: "#fb866a" }}></i> <a className="app-link" href="https://www.digiweb.bj/" target="_blank">Digiweb SARL</a> 2023</small>

                            </div>
                        </footer>{/*//app-auth-footer*/}
                    </div>{/*//flex-column*/}
                </div>{/*//auth-main-col*/}
                <div className="col-12 col-md-5 col-lg-5 h-100 auth-background-col app-signup">
                    <div className="auth-background-holder">
                    </div>
                    <div className="auth-background-mask">
                    </div>
                </div>

            </div>{/*//row*/}
        </React.Fragment>
    )
}